import { plugin } from 'light-component';
import { theme } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { useTranslation } from '../../i18n';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function WidgetNoData(): ReactElement {
  const [t] = useTranslation();
  const { token } = theme.useToken();

  return (
    <div className={styles.emptyBox}>
      <Icons name='EmptyIcon' style={{ color: token.colorPrimary }} />
      <span className={styles.emptyText}>
        {t('暂无数据')}
      </span>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'nodata', component: WidgetNoData });
